module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p1.7ac89fc3.png";